"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-felice-a-cancello": {
    "080cb340": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "botteghino": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "db51f85b": [{
      "hkey": "eeedba9f",
      "slug": "cancello-scalo",
      "name": "Cancello Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "cancello": [{
      "hkey": "eeedba9f",
      "slug": "cancello-scalo",
      "name": "Cancello Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1d3a4626": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "skipSearch": false
    }],
    "cave": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10ba65ac": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "skipSearch": false
    }],
    "coste": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e634fd5a": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "skipSearch": false
    }],
    "felicione": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "11e2a49e": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "grotticelle": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-felice-a-cancello"
    }],
    "b649f773": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "skipSearch": false
    }],
    "piedarienzo": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d51dd475": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "ponti-rossi": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-felice-a-cancello"
    }],
    "7c35cec3": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "65757ec4",
      "slug": "botteghino-grotticelle-ponti-rossi-san-marco",
      "name": "Botteghino-Grotticelle-Ponti Rossi-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-felice-a-cancello"
    }],
    "f1f1d5de": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agnello": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b21c325f": [{
      "hkey": "ba4545fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "talanico": [{
      "hkey": "ba4545fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-felice-a-cancello"
    }],
    "97f12619": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "skipSearch": false
    }],
    "trotti": [{
      "hkey": "eb4546e6",
      "slug": "san-felice-a-cancello",
      "name": "San Felice a Cancello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7185306": [{
      "hkey": "ba4545fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vigliotti": [{
      "hkey": "ba4545fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-felice-a-cancello"
    }]
  }
};
exports["default"] = _default;